import { render, staticRenderFns } from "./Badge11.vue?vue&type=template&id=21047a84&scoped=true"
import script from "./Badge11.vue?vue&type=script&lang=js"
export * from "./Badge11.vue?vue&type=script&lang=js"
import style0 from "./Badge11.vue?vue&type=style&index=0&id=21047a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21047a84",
  null
  
)

export default component.exports